// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JointViewForm_container__c\\+UeC {
  min-height: 100vh;
  max-width: 100%;
  padding: 16px;
}

.JointViewForm_loading__GDMSJ {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
}

.JointViewForm_tableWrapper__29y\\+O {
  margin-top: -16px;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/JointForm/JointViewForm.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".container {\r\n  min-height: 100vh;\r\n  max-width: 100%;\r\n  padding: 16px;\r\n}\r\n\r\n.loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 50vh;\r\n}\r\n\r\n.tableWrapper {\r\n  margin-top: -16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `JointViewForm_container__c+UeC`,
	"loading": `JointViewForm_loading__GDMSJ`,
	"tableWrapper": `JointViewForm_tableWrapper__29y+O`
};
export default ___CSS_LOADER_EXPORT___;
